import { FC, useState } from "react";
import GiftCards from "../../../components/Booking-clientSide/gift-cards/GiftCards";
import GiftCardsSideBar from "../../../components/Booking-clientSide/gift-cards/GiftCardsSideBar";
import CreditCardForm from "../../../components/common/CreditCardForm";
import { infoSVG } from "../../../assets/SVGs/SVGs";

interface CheckoutGiftCardsProps {}

const CheckoutGiftCards: FC<CheckoutGiftCardsProps> = ({}) => {
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: "",
    name: "",
    cvv: "",
    expiry: "",
  });
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 max-h-[100vh] p-1 overflow-y-auto">
      <div className="col-span-1 md:col-span-2 ">
        <div className="shadow p-6 space-y-4 rounded-lg ">
          <div>
            <h4 className="text-color-primary text-xl ">الدفع</h4>
            <p className="text-color-sec-title">
              ادفع الان و قم بتأكيد حجز موعدك{" "}
            </p>
          </div>
          <CreditCardForm
            paymentDetails={paymentDetails}
            setPaymentDetails={setPaymentDetails}
          />
          <div className="flex justify-center gap-1 items-start">
            <span>{infoSVG}</span>
            <p>سيتم ارسال الفاتورة الى البيرد الالكتروني الخاص بك</p>
          </div>
        </div>
      </div>
      <div className="col-span-1  ">
        <GiftCardsSideBar />
      </div>
    </div>
  );
};

export default CheckoutGiftCards;
